export const tradeInQueries = {
  tradeInOrders: () => ['trade-in/orders'],
  tradeInOrder: (orderId: string) => ['ecom-policy/ecom-order', orderId],
}
